// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.q1mrzR {
  display: flex;
  justify-content: center;
  align-items: flex-start;
  padding: 32px 24px;
  font-family: var(--font-family-base, 'Source Sans 3', sans-serif);
  min-height: 200px;
}

.o1oP9R {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  max-width: 544px;
  gap: 24px;
}

._XOYcD {
  display: flex;
  flex-direction: column;
  align-self: stretch;
  gap: 4px;
}

.PhTtkw {
  font-size: 20px;
  font-weight: 600;
  line-height: 1.42em;
  color: #1f1f1f;
  margin: 0;
  text-align: left;
}

.Q4HFd9 {
  display: flex;
  justify-content: center;
  align-items: center;
  align-self: stretch;
  height: 1px;
  border-top: 1px solid #f2f2f2;
}

.wCqTjP {
  display: flex;
  flex-direction: column;
  align-self: stretch;
  gap: 16px;
}

.n5E3wq {
  display: flex;
  flex-direction: column;
  align-self: stretch;
  gap: 16px;
}

.xCe90R {
  display: flex;
  flex-direction: column;
  align-self: stretch;
  gap: 16px;
}

.x5CY8b {
  display: flex;
  flex-direction: column;
  align-self: stretch;
  gap: 16px;
  width: 100%;
}

.Ta6e8g {
  text-align: left;
  margin: 0;
  width: 100%;
  display: flex;
  align-items: center;
  font-family: var(--font-family-base);
  font-weight: var(--font-weight-regular);
  font-size: var(--font-size-md);
  line-height: var(--line-height-180);
  color: var(--text-neutral-dark);
  height: 25px;
}

@media (max-width: 768px) {
  .Ta6e8g {
    font-size: 1.25rem;
    margin-bottom: 0.75rem;
  }
}
`, "",{"version":3,"sources":["webpack://./../../packages/shared-ui/src/components/AppSupport/AppSupport.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,uBAAuB;EACvB,uBAAuB;EACvB,kBAAkB;EAClB,iEAAiE;EACjE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;EACd,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,mBAAmB;EACnB,WAAW;EACX,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;EACT,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,oCAAoC;EACpC,uCAAuC;EACvC,8BAA8B;EAC9B,mCAAmC;EACnC,+BAA+B;EAC/B,YAAY;AACd;;AAEA;EACE;IACE,kBAAkB;IAClB,sBAAsB;EACxB;AACF","sourcesContent":[".container {\n  display: flex;\n  justify-content: center;\n  align-items: flex-start;\n  padding: 32px 24px;\n  font-family: var(--font-family-base, 'Source Sans 3', sans-serif);\n  min-height: 200px;\n}\n\n.content {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  width: 100%;\n  max-width: 544px;\n  gap: 24px;\n}\n\n.titleSection {\n  display: flex;\n  flex-direction: column;\n  align-self: stretch;\n  gap: 4px;\n}\n\n.pageTitle {\n  font-size: 20px;\n  font-weight: 600;\n  line-height: 1.42em;\n  color: #1f1f1f;\n  margin: 0;\n  text-align: left;\n}\n\n.divider {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  align-self: stretch;\n  height: 1px;\n  border-top: 1px solid #f2f2f2;\n}\n\n.contactSection {\n  display: flex;\n  flex-direction: column;\n  align-self: stretch;\n  gap: 16px;\n}\n\n.linksSection {\n  display: flex;\n  flex-direction: column;\n  align-self: stretch;\n  gap: 16px;\n}\n\n.socialSection {\n  display: flex;\n  flex-direction: column;\n  align-self: stretch;\n  gap: 16px;\n}\n\n.bannersSection {\n  display: flex;\n  flex-direction: column;\n  align-self: stretch;\n  gap: 16px;\n  width: 100%;\n}\n\n.bannersTitle {\n  text-align: left;\n  margin: 0;\n  width: 100%;\n  display: flex;\n  align-items: center;\n  font-family: var(--font-family-base);\n  font-weight: var(--font-weight-regular);\n  font-size: var(--font-size-md);\n  line-height: var(--line-height-180);\n  color: var(--text-neutral-dark);\n  height: 25px;\n}\n\n@media (max-width: 768px) {\n  .bannersTitle {\n    font-size: 1.25rem;\n    margin-bottom: 0.75rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `q1mrzR`,
	"content": `o1oP9R`,
	"titleSection": `_XOYcD`,
	"pageTitle": `PhTtkw`,
	"divider": `Q4HFd9`,
	"contactSection": `wCqTjP`,
	"linksSection": `n5E3wq`,
	"socialSection": `xCe90R`,
	"bannersSection": `x5CY8b`,
	"bannersTitle": `Ta6e8g`
};
module.exports = ___CSS_LOADER_EXPORT___;
